"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    RED = "".concat(_vars.COLOURS.red.thunderBird, " !important"),
    _default = (0, _cxs["default"])({
  backgroundColor: RED,
  color: _vars.COLOURS.mono.white,
  ".place-right:after": {
    borderRightColor: RED
  },
  ".place-bottom:after": {
    borderBottomColor: RED
  },
  ".place-top:after": {
    borderTopColor: RED
  },
  ".place-left:after": {
    borderLeftColor: RED
  },
  fontSize: "10px",
  padding: "15px",
  opacity: "1 !important"
});

exports["default"] = _default;